"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TitleLevels = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Base = _interopRequireDefault(require("./Base"));
var _ButtonGroup = require("../../lib/Button/ButtonGroup");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var levels = [1, 2, 3, 4, 5, 6];
var TitleLevels = exports.TitleLevels = levels.map(function (level) {
  return "h".concat(level);
});
var Title = exports.default = /*#__PURE__*/function (_Component) {
  function Title() {
    (0, _classCallCheck2.default)(this, Title);
    return _callSuper(this, Title, arguments);
  }
  (0, _inherits2.default)(Title, _Component);
  return (0, _createClass2.default)(Title, [{
    key: "render",
    value: function render() {
      var level = 'h1';
      if (this.props.level) {
        level = "h".concat(this.props.level);
      }
      return /*#__PURE__*/_react.default.createElement(_Base.default, (0, _extends2.default)({}, this.props, {
        component: level
      }));
    }
  }]);
}(_react.Component);
Title.propTypes = {
  prefixCls: _propTypes.default.string,
  /**
   * Additional CSS ui classes
   */
  className: _propTypes.default.string,
  level: _propTypes.default.oneOf(levels),
  code: _propTypes.default.bool,
  copyable: _propTypes.default.bool,
  delete: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  editable: _propTypes.default.bool,
  ellipsis: _propTypes.default.bool,
  mark: _propTypes.default.bool,
  keyboard: _propTypes.default.bool,
  underline: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  strong: _propTypes.default.bool,
  type: _propTypes.default.oneOf(['success', 'secondary', 'warning', 'danger'])
};
Title.defaultProps = {
  level: 1,
  code: false,
  copyable: false,
  delete: false,
  disabled: false,
  editable: false,
  ellipsis: false,
  mark: false,
  keyboard: false,
  underline: false,
  strong: false
};